import React from 'react';
import ReactDOM from 'react-dom';
import { polyfill } from 'es6-promise';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap/dist/css/bootstrap-theme.css';
import './css/index.css';

import { Provider } from 'react-redux';
import { configureStore } from './utils';

const store = configureStore();

polyfill();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js